"use client"
 
import { UserPolicyMappingPage } from "../../../modules/leave-management/user-policy-mapping"

interface UserPolicyMappingProps {
  sidebarOpen?: boolean
}

export default function UserPolicyMapping({sidebarOpen }: UserPolicyMappingProps) {
  return <UserPolicyMappingPage />
}

